import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";

const STATUSES = ["new", "contacted", "converted", "closed", "rejected"];

export default function TAdminEnquiries() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => api.get(`/tenant/enquiries${filter ? `?status=${filter}` : ""}`).then((r) => setList(r.data));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [filter]);

  const setStatus = async (id, status) => {
    await api.put(`/tenant/enquiries/${id}/status`, { status });
    toast.success("Updated"); load();
  };

  const wa = (e) => {
    const text = `Hi ${e.customer_name}, thanks for reaching out for ${e.service_name || "our service"}. How can we help?`;
    const num = (e.customer_phone || "").replace(/[^0-9]/g, "");
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(text)}`, "_blank");
  };

  return (
    <div data-testid="tadmin-enquiries">
      <div className="flex flex-wrap justify-between items-end gap-3 mb-6">
        <div><div className="admin-overline">Inbox</div><h1 className="admin-heading text-3xl font-bold mt-1">Enquiries</h1></div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} aria-label="Filter by status" className="border border-neutral-300 bg-white px-3 py-2 text-xs min-h-[44px]">
          <option value="">All</option>
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="space-y-3" data-testid="tadmin-enquiries-list">
        {list.length === 0 && <div className="bg-white border border-neutral-200 p-12 text-center text-sm text-neutral-500">No enquiries.</div>}
        {list.map((e) => (
          <div key={e.id} className="bg-white border border-neutral-200 p-4 sm:p-5">
            <div className="flex flex-wrap justify-between items-start gap-3">
              <div className="min-w-0">
                <div className="font-mono text-xs text-neutral-500">{e.code}</div>
                <div className="font-bold mt-0.5 break-words">{e.customer_name} · {e.customer_phone}</div>
                {e.service_name && <div className="text-sm text-neutral-700">Service: {e.service_name}</div>}
                {e.location && <div className="text-xs text-neutral-500">📍 {e.location}</div>}
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => wa(e)} className="icon-btn bg-green-50 text-green-700" title="WhatsApp" aria-label="Reply on WhatsApp"><MessageCircle className="h-4 w-4" /></button>
                <select value={e.status} onChange={(ev) => setStatus(e.id, ev.target.value)} aria-label="Status" className="border border-neutral-300 bg-white px-2 py-2 text-xs uppercase" data-testid={`tadmin-enquiry-status-${e.id}`}>
                  {STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select>
              </div>
            </div>
            {e.message && <p className="text-sm text-neutral-700 mt-3 leading-relaxed border-l-2 border-neutral-200 pl-3 break-words">{e.message}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
